<template>
<div>
  <form @submit.prevent="doRoomOrSearch">
      <b-input size="sm" class="mr-sm-2 stroominput"
        v-model.trim="valRoomSearch" autocomplete="off"
        v-on:keyup="doRoomOrSearchKey"
        :placeholder="placeholder"
        ref="room-input"
        >
      </b-input>
      <div :class="optclasses" :style="custstyle"
        v-if="valRoomSearch && valRoomSearch != '@' && acRooms">
        <span v-for="(past) in acRooms">
          <span class="st-pastbtn"
            @click="selectAcRoom(past)"
            variant="outline-primary">
            {{ past }}
          </span>
       </span>
      </div>
      <div :class="optclasses" :style="custstyle"
        v-if="pastRooms && valRoomSearch == '@'">
        <span v-for="(past) in pastRooms">
          <span class="st-pastbtn"
            @click="selectPastRoom(past)"
            variant="outline-primary">
            {{ past }}
          </span>
       </span>
      </div>
  </form>
</div>
</template>

<script>

export default {
  name: "SearchTransfer",
  props: ["placeholder","pastRooms","add2Past","ontop","usestyle","nosearch", "clrsearch", "clrroom"],
  components: {
  },
  watch: {
  },
  data() {
    return  {
       valRoomSearch: "",
       acRooms: [],
       msg: "",
       prv_len: 0,
       optclasses: "optrooms optroomsbot",
       custstyle: "",
       clr_on_submit_search: false,
       clr_on_submit_room: true,
    };
  },
  computed: {
  },
  created: function() {
  },
  mounted: function() {
    let vue = this;
    if (vue.ontop) {
      /* Put suggestions on top instead of below */
      vue.optclasses = "optrooms optroomstop";
    } else if (vue.usestyle) {
      vue.optclasses = "optrooms";
      vue.custstyle = vue.usestyle;
    }
    if (vue.clrsearch == "false") {
      vue.clr_on_submit_search = false;
    } else if (vue.clrsearch == "true") {
      vue.clr_on_submit_search = true;
    }
    if (vue.clrroom == "false") {
      vue.clr_on_submit_room = false;
    } else if (vue.clrroom == "true") {
      vue.clr_on_submit_room = true;
    }
  },
  methods: {
    doRoomOrSearchKey(ev) {
      let vue = this;
      let val = ""+vue.valRoomSearch;
      let m, acc, room;
      if (vue.nosearch && val.charAt(0) != "@") {
         val = "@"+val;
      }
      if ((m = val.match(/@([a-zA-Z0-9_-]+)[:\\/]([a-zA-Z0-9_-]+)/))) {
        acc = m[1];
        room = m[2];
      } else if ((m = val.match(/@([a-zA-Z0-9_-]+)/))) {
        acc = window.vx.acc;
        room = m[1];
      } else {
        /* Search Home */
        if (ev.code == "Submit") {
          vue.$emit("search",{q:val});
          if (vue.clr_on_submit_search) {
            vue.valRoomSearch = "";
          }
        }
        return;
      }
      if (!room || room.length < 2) {
        return;
      }

      clearTimeout(vue.ros_tid);
      if (ev.code == "Submit") {
         if (vue.add2Past) {
           if (vue.skipExistsCheck) {
             vue.add2Past(val);
           } else {
             vue.roomExists(val, function(exists) {
                exists && vue.add2Past(val);
             });
           }
         }
         vue.$emit("room",{acc:acc, room:room});
         if (vue.clr_on_submit_room) {
           vue.valRoomSearch = "";
         }
         vue.acRooms = [];
         return;
      } else if (ev.code == "Enter") {
        /* Ignore 'Enter' since we use 'Submit'*/
      } else if (acc == window.vx.acc) {
        vue.ros_tid = setTimeout(function() {
          vue.updateAutoComplete(room);
        }, 300);
      }
      vue.skipExistsCheck = false;
    },
    selectPastRoom: function(name) {
      let vue = this;
      vue.valRoomSearch = name;
      vue.skipExistsCheck = true;
      vue.acRooms = [];
      if (vue.$refs["room-input"]) {
        vue.$refs["room-input"].focus();
      }
      //console.log("selected past room ",vue.acRooms.length);
    },
    selectAcRoom: function(name) {
      let vue = this;
      vue.valRoomSearch = "@"+name;
      vue.skipExistsCheck = true;
      if (vue.$refs["room-input"]) {
        vue.$refs["room-input"].focus();
      }
    },

    doRoomOrSearch() {
      let vue = this;
      vue.doRoomOrSearchKey({code:"Submit"});
    },

    getVal() {
      let val = ""+this.valRoomSearch;
      val = val.replace("@","");
      return val; 
    },
    isRoom() {
      let val = ""+this.valRoomSearch;
      if (val.indexOf("@") >= 0) { return true; }
      return false;
    },
    roomExists: function (room, cb) {
      let vue = this;
      window.wss_send_cb(window.vx, "ac_room_ctrl", {
        txt: room,
      }, function(msg) {
        if (!msg || !msg.data || !msg.data.rooms) { return; }
        let exists = false;
        msg.data.rooms.forEach(function(v) {
          if (("@"+v.room) == room) { exists = true; }
        });
        cb(exists);
      });
    },
    updateAutoComplete: function (room) {
      let vue = this;
      window.wss_send_cb(window.vx, "ac_room_ctrl", {
        txt: room,
      }, function(msg) {
        if (!msg || !msg.data || !msg.data.rooms) { return; }
        vue.acRooms = [];
        msg.data.rooms.forEach(function(r) {
          vue.acRooms.push(r.room);
        });
      });
    }
  },
}
</script>

<style lang="scss" scoped>

.optrooms {
  display:none;
  position:absolute;
  /*background:#1a1a1d;*/
  border-radius: 0.25rem;
  line-height: 1.4rem;
}
.optroomstop {
  bottom:40px;
}
.optroomsbot {
  top:40px;
}
.stroominput:focus + .optrooms {
  display:block;
  z-index:10;
}
.optrooms:hover, .optrooms:focus {
  display:block;
  z-index:10;
}

.st-pastbtn {
 padding:0 0.3rem;
 margin:1px;
 font-size: 0.9rem;
 background: black;
 color:#007bff;
 border: 1px solid #007bff;
 border-radius: 5px;
 padding: 0.1rem 0.25rem;
}

.st-pastbtn:hover {
 background:#007bff;
 color:white;
}

</style>